<script>
  import { t } from '../../../locale';
  import Button from '../../Button/Button.vue';
  import Checkbox from '../../Checkbox/Checkbox.vue';

  export default {
    name: 'bulk-actions',

    components: {
      'll-button': Button,
      'll-checkbox': Checkbox,
    },

    props: {
      allowSelectAll: Boolean,
      isAllPageChecked: Boolean,
      isSomePageChecked: Boolean,
      hideBulkActionOptions: Boolean,
      hideNumberOfTotalSelected: Boolean,
      totalCount: {
        type: Number,
        default: 0,
      },
      totalSelectedCount: {
        type: Number,
        default: 0,
      },
    },

    emits: ['change:select-current', 'change:select-all', 'change:clear-selected'],

    data: function () {
      return {
        selectAllText: t('ll.listView.selectAll'),
      };
    },

    computed: {
      clearSelectedText() {
        if (this.allowSelectAll) {
          return t('ll.listView.deselectAllCount', { count: this.totalCount });
        }

        return t('ll.listView.clearSelection');
      },

      showSelectAll() {
        return [this.totalSelectedCount !== this.totalCount, this.allowSelectAll].every(Boolean);
      },

      numberOfTotalSelectedText() {
        return t('ll.listView.numberOfTotalSelected', {
          num: this.totalSelectedCount,
          total: this.totalCount,
        });
      },

      selectAllCountText() {
        return t('ll.listView.selectAllCount', { count: this.totalCount });
      },

      numItemsSelectedText() {
        return t('ll.listView.numItemsSelected', {
          totalSelectedCount: this.totalSelectedCount,
          totalCount: this.totalCount,
        });
      },
    },

    methods: {
      onSelectPage(value) {
        this.$emit('change:select-current', value);
      },

      selectAll() {
        this.$emit('change:select-all');
      },

      clearSelected() {
        this.$emit('change:clear-selected');
      },
    },
  };
</script>

<template>
  <div
    class="lg:flex"
    :class="[
      $style['select-bar'],
      {
        'lg:hidden': hideBulkActionOptions,
      },
      'p-3',
    ]"
  >
    <div
      class="flex items-center"
      :class="{
        'justify-between': !hideBulkActionOptions,
      }"
    >
      <ll-checkbox
        data-test="checkbox|bulk-actions"
        :class="$style.checkbox"
        class="m-0 lg:hidden"
        :checked="isSomePageChecked && !!totalCount"
        :indeterminate="isSomePageChecked && !isAllPageChecked"
        :label="!totalSelectedCount ? selectAllText : ''"
        @update:checked="onSelectPage"
      />
      <div v-if="!!totalSelectedCount && !hideBulkActionOptions" class="flex flex-1 items-center justify-between">
        <div v-if="!hideNumberOfTotalSelected" class="text-xs">
          {{ numberOfTotalSelectedText }}
        </div>
        <div :class="{ 'ml-3': !hideNumberOfTotalSelected }">
          <ll-button v-if="showSelectAll" inline @click="selectAll">{{ selectAllCountText }}</ll-button>
          <ll-button v-else inline @click="clearSelected">
            {{ clearSelectedText }}
          </ll-button>
        </div>
      </div>
      <div v-else-if="hideBulkActionOptions && !!totalSelectedCount" class="ml-1.5 lg:hidden">
        <h4>{{ numItemsSelectedText }}</h4>
      </div>
    </div>
    <div v-if="!!totalSelectedCount && !hideBulkActionOptions" :class="$style.actions">
      <slot name="bulk-actions-content"></slot>
    </div>
  </div>
</template>

<style module>
  @reference "../../../../styles/main.css";

  .select-bar {
    @media (width >= theme(--breakpoint-lg)) {
      border-bottom: 1px solid var(--color-ice-200);
      justify-content: center;
      vertical-align: middle;
    }
  }

  .checkbox {
    flex: 0 0 auto;
  }

  .actions > * {
    margin-top: --spacing(6);
    width: 100%;

    @media (width >= theme(--breakpoint-lg)) {
      margin-left: --spacing(3);
      margin-top: 0;
      width: auto;
    }
  }
</style>
